{
  "deleteChannel": "Delete alert channel",
  "alertSent": "Alert sent",
  "alertNotSent": "Alert failed",
  "sendAlert": "Send an alert",
  "atTheEndOf": "At the end of",
  "immediatelyAfter": "Immediately after",
  "when": "When",
  "whenLessThan": "When fewer than",
  "matchesAppear": "appears within",
  "matchesAppear_plural": "appear within",
  "moreMatchesAppear": "or more appears within",
  "moreMatchesAppear_plural": "or more appear within",
  "triggerLimit": "Trigger limit",
  "triggerInterval": "Trigger interval",
  "sendAtEndOf": "Send an alert at the end of",
  "logLinesFrom": "Log lines from",
  "logLines": "Log Lines",
  "loadingLogLines": "Loading log lines...",
  "logLinesHint": "Number of log lines matched for this view per alert interval.",
  "muted": {
    "disabledBy": "was disabled by {{ originator }} until {{ until }}",
    "unmute": "Unmute"
  },
  "autoResolveIncidents": "Auto-resolve incidents",
  "resolveWhenLessThan": "Resolve incidents when fewer than",
  "resolveWhen": "Resolve incidents when",
  "detachAlertFromView": "Detach alert channels from <strong>{{ viewName }}</strong>?",
  "summary": {
    "whenLinesAppearWithinInterval": "When <strong>{{ count }}</strong> or more lines appear within <strong>{{ interval }}</strong>",
    "sendImmediatelyAndAtEnd": "send an alert immediately after 1 line as well as at the end of the interval",
    "sendImmediatelyAndAtEnd_plural": "send an alert immediately after {{ count }} lines as well as at the end of the interval",
    "sendAlertImmediately": "send an alert immediately after 1 line",
    "sendAlertImmediately_plural": "send an alert immediately after {{ count }} lines",
    "sendAtEnd": "send an alert at the end of the interval",
    "absence": "When fewer than <strong>1</strong> line appears within <strong>{{ interval }}</strong>, send an alert at the end of the interval.",
    "absence_plural": "When fewer than <strong>{{ count }}</strong> lines appear within <strong>{{ interval }}</strong>, send an alert at the end of the interval."
  },
  "channels": {
    "slack": "Slack",
    "email": "Email",
    "webhook": "Webhook",
    "pagerduty": "PagerDuty",
    "appoptics": "AppOptics/Librato",
    "victorops": "VictorOps",
    "opsgenie": "OpsGenie",
    "datadog": "Datadog",
    "sysdig": "Sysdig",
    "addOneRequired": "Please add at least one channel"
  },
  "apiKeyRequired": "An API key is required",
  "unknownChannel": "Unknown channel",
  "sysdig": {
    "useThisUrl": "Use this URL",
    "urlRequired": "A Sysdig instance URL is required",
    "severity": {
      "none": "None",
      "info": "Info",
      "low": "Low",
      "medium": "Medium",
      "high": "High"
    },
    "popovers": {
      "key": "Copy the existing Sysdig Monitor API key by going to Settings → User Profile. See the <span><a href='{{ url }}' target='_blank'>Sysdig documentation</a></span> for details.",
      "url": "This URL is the base URL for your Sysdig Monitor instance. See the <span><a href='{{ url }}' target='_blank'>Sysdig documentation</a></span> for details.",
      "severity": "All alerts triggered by this alert channel will have this severity. See the <span><a href='https://docs.sysdig.com/en/severity-and-status.html' target='_blank'>Sysdig documentation</a></span> for details."
    }
  },
  "webhook": {
    "methodAndUrl": "Method & URL",
    "headers": "Headers",
    "body": "Body",
    "validateJson": "Validate JSON",
    "tokens": "Tokens",
    "tokenHelpText": "Use the following tokens in the webhook body to access specific information about the view or the matched lines that trigger the alert",
    "tooltips": {
      "string": "This token returns a string value",
      "array": "This token returns an array value",
      "object": "This token returns an object value"
    },
    "tokenDescriptions": {
      "name": "View name",
      "matches": "Number of matched lines",
      "lines": "Raw output of matched lines",
      "level": "Severity level",
      "query": "View query",
      "url": "View URL, with first matched line when possible",
      "app": "Apps from first matched line",
      "host": "Host from first matched line",
      "tag": "Tags from first matched line",
      "line": "Text from first matched line",
      "lineObjects": "Array of line objects",
      "firstLineObject": "First matched line object"
    },
    "urlRequired": "A webhook URL is required",
    "methodRequired": "A webhook method is required",
    "bodyValid": "Webhook body is valid json.",
    "bodyInvalid": "Webhook body is invalid json."
  },
  "pagerduty": {
    "service": "Service",
    "selectService": "Select a service",
    "add": "Add PagerDuty",
    "addDescription": "Connect to PagerDuty to add a service.",
    "managerAccessRequired": "Please make sure you have ‘Manager’ access on your PagerDuty account before adding the integration.",
    "noServiceError": "Please choose a service",
    "connectError": "Unable to connect service"
  },
  "presets": {
    "title": "Presets",
    "addPreset": "Add Preset",
    "noPresetsYet": "You haven't created any alert presets yet.",
    "createPresetTitle": "Create a preset",
    "presetNameRequired": "A preset name is required",
    "presetNamePlaceholder": "Preset name"
  },
  "viewSpecific": {
    "title": "View-Specific Alerts",
    "noAlertsYet": "You haven't created any view-specific alerts yet.",
    "noFilteredAlerts": "No view-specific {{filter}} alerts.",
    "editAlertsFor": "Edit alerts for {{name}}",
    "editPreset": "Edit {{name}}"
  }
}
